import { render, staticRenderFns } from "./UnallocatedPayments.vue?vue&type=template&id=823aa3fe&"
import script from "./UnallocatedPayments.vue?vue&type=script&lang=js&"
export * from "./UnallocatedPayments.vue?vue&type=script&lang=js&"
import style0 from "./UnallocatedPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports